import React, { ButtonHTMLAttributes, forwardRef } from 'react'
import classNames from 'classnames'

import { BaseButton, BaseButtonProps, BaseButtonContent } from './BaseButton'

export type ButtonProps = ButtonHTMLAttributes<HTMLElement> &
  Omit<BaseButtonProps, 'children'>

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function ButtonWithForwardedRef(
    {
      variant,
      size,
      icon,
      iconShape,
      iconColor,
      iconVariant,
      iconClassName,
      iconPosition,
      iconSize,
      children,
      disabled,
      className,
      style,
      isActive,
      rounded,
      ...props
    },
    ref
  ) {
    return (
      <BaseButton
        variant={variant}
        size={size}
        disabled={disabled}
        isActive={isActive}
        rounded={rounded}
      >
        {(_className, _style) => (
          <button
            {...props}
            ref={ref}
            disabled={disabled}
            type={props.type ?? 'button'}
            className={classNames(className, _className)}
            style={{ ..._style, ...style }}
          >
            <BaseButtonContent
              icon={icon}
              iconShape={iconShape}
              iconColor={iconColor}
              iconVariant={iconVariant}
              iconClassName={iconClassName}
              content={children}
              size={size}
              iconPosition={iconPosition}
              iconSize={iconSize}
            />
          </button>
        )}
      </BaseButton>
    )
  }
)
